import React, { useEffect } from 'react';
import { CheckPicker } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAll as getAssociatedDomainOptions,
  getFetched
} from '../../redux/Guest/selectors/associated-domain-options';
import { fetchAssociatedDomainOptions } from '../../redux/Guest/sagas/routines';

export default function AssociatedDomainCheckPicker(props) {
  const dispatch = useDispatch();
  const domainOptions = useSelector(getAssociatedDomainOptions);
  const isFetched = useSelector(getFetched);

  useEffect(
    () => {
      if (!isFetched) dispatch(fetchAssociatedDomainOptions());
    },
    [isFetched]
  );

  return <CheckPicker {...props} data={domainOptions} />;
}
